// extracted by mini-css-extract-plugin
export default {"overlay":"Ce4zDIqayhfY6y2nppuMNw=="};